import apiConfigs from "./config";

const CREATOR_MOBILE_TABLE_HEADER = [
  { title: "name", width: "70%" },
  { title: "status", width: '30%' }
];
const REEL_MOBILE_TABLE_HEADER = [
  { title: "name", width: "70%" },
  { title: "status", width: '30%' }
];

const CREATOR_TABLE_HEADER = [
  { title: "", width: '3%' },
  { title: "name", width: "30%" },
  { title: "id", width: "7%" },
  { title: "type", width: "5%" },
  { title: "survey", width: "5%" },
  { title: "clips", width: '7%' },
  { title: "imm", width: '4%' },
  { title: "sfty", width: '5%' },
  { title: "status", width: '9%' },
  { title: "start", width: '10%' },
  { title: "end", width: '10%' },
  { title: "participants", width: '5%' },
];

const CREATOR_TABLE_HEADER_WITH_USER = [
  { title: "", width: '3%' },
  { title: "name", width: "28%" },
  { title: "id", width: "7%" },
  { title: "type", width: "5%" },
  { title: "survey", width: "5%" },
  { title: "clips", width: '5%' },
  { title: "imm", width: '4%' },
  { title: "sfty", width: '5%' },
  { title: "status", width: '9%' },
  { title: "start", width: '8%' },
  { title: "end", width: '8%' },
  { title: "participants", width: '5%' },
  { title: "owner", width: '8%' },
];

const CREATOR_TABLE_SUBHEADER = [
  { title: "", width: '5%' },
  { title: "name", width: "42%" },
  { title: "immersion", width: '9%' },
  { title: "safety", width: '9%' },
  { title: "length", width: '9%' },
  { title: "start", width: '9%' },
  { title: "end", width: '9%' },
  { title: "", width: '8%' }
];

const CREATOR_CLIP_TABLE_SUBHEADER = [
  { title: "", width: '4%' },
  { title: "name", width: "32%" },
  { title: "Experience name", width: "20%" },
  { title: "immersion", width: '8%' },
  { title: "safety", width: '6%' },
  { title: "length", width: '9%' },
  { title: "start", width: '9%' },
  { title: "end", width: '9%' },
  { title: "", width: '3%' },
];

const CREATOR_COMPARE_TABLE_HEADER = [
  { title: "", width: 35, category: 'blank' },
  { title: "name", width: "100%", category: 'name' },
  { title: "immersion", width: 110, mobileWidth: 80, category: '' },
  { title: "captivated", width: 110, mobileWidth: 80, category: 'immersion' },
  { title: "absorbed", width: 110, mobileWidth: 80, category: 'immersion' },
  { title: "interested", width: 110, mobileWidth: 80, category: 'immersion' },
  { title: "indifferent", width: 110, mobileWidth: 80, category: 'immersion' },
  { title: "tuned out", width: 110, mobileWidth: 80, category: 'immersion' },

  { title: "", width: 3, category: 'separator' },

  { title: "safety", width: 110, mobileWidth: 80, category: '' },
  { title: "zen", width: 110, mobileWidth: 80, category: 'safety' },
  { title: "very safe", width: 110, mobileWidth: 80, category: 'safety' },
  { title: "safe", width: 110, mobileWidth: 80, category: 'safety' },
  { title: "unsafe", width: 110, mobileWidth: 80, category: 'safety' },
  { title: "very unsafe", width: 110, mobileWidth: 80, category: 'safety' },
];

const IMMERSION_CATEGORIES = ['Captivated', 'Absorbed', 'Interested', 'Indifferent', 'Tuned Out']
const SAFETY_CATEGORIES = ['Zen', 'Very Safe', 'Safe', 'Unsafe', 'Very Unsafe']

const PARTICIPANT_TABLE_HEADER_UPCOMING = [
  { title: 'name', width: '24%', param: 'name', img: true },
  { title: 'invited by', width: '18%', param: 'inviter' },
  { title: 'status', width: '16%', param: 'status' },
  { title: 'type', width: '12%', param: 'type' },
  { title: 'length', width: '12%', param: 'length' },
  { title: 'date & time', width: '18%', param: 'dateTime' },
]

const PARTICIPANT_TABLE_HEADER_COMLETED = [
  { title: 'name', width: '28%', param: 'name', img: true },
  { title: 'invited by', width: '26%', param: 'inviter' },
  { title: 'date completed', width: '20%', param: 'completed' },
  { title: 'immersion', width: '13%', param: 'immersion' },
  { title: 'safety', width: '13%', param: 'safety' },
]
const PARTICIPANT_TABLE_HEADER = [
  { title: "name", width: "20%" },
  { title: "invited by", width: "20%" },
  { title: "status", width: "20%" },
  { title: "type", width: "10%" },
  { title: "length", width: "10%" },
  { title: "date & time", width: "20%" },
];

const REELS_TABLE_HEADER = [
  { title: "", width: "3%" },
  { title: "name", width: "30%" },
  { title: "id", width: "7%" },
  { title: "survey", width: "5%" },
  { title: "experiences in reel", width: "20%" },
  { title: "status", width: "10%" },
  { title: "start", width: "10%" },
  { title: "end", width: "10%" },
  { title: "participants", width: "5%" },
];

const CREATOR_REELS_TABLE_SUBHEADER = [
  { title: "", width: '3%' },
  { title: "name", width: "33%" },
  { title: "immersion", width: '12%' },
  { title: "safety", width: '13%' },
  { title: "status", width: '10%' },
  { title: "start", width: '10%' },
  { title: "end", width: '10%' },
  { title: "participants", width: '9%' },
];

const PARTICIPANT_DASHBOARD_MENU = [
  { id: 1, name: 'Upcoming', active: '/assets/icons/participant/clock-active.svg', deactive: '/assets/icons/participant/clock-deactive.svg', },
  { id: 2, name: 'Completed', active: '/assets/icons/participant/check-active.svg', deactive: '/assets/icons/participant/check-deactive.svg', },
]

const ANALYZE_TABBAR_TITLES = [
  {
    id: 1,
    label: 'Setup',
    path: '/participants'
  },
  {
    id: 2,
    label: 'Report Card',
    path: '/overview'
  },
  {
    id: 3,
    label: 'Second-by-Second',
    path: '/analyze'
  },
  {
    id: 4,
    label: 'Comparison',
    path: '/compare'
  }
];

const ANALYZE_TABBAR_TITLES_NO_COMPARE = [
  {
    id: 1,
    label: 'Setup',
    path: '/participants'
  },
  {
    id: 2,
    label: 'Report Card',
    path: '/overview'
  },
  {
    id: 3,
    label: 'Second-by-Second',
    path: '/analyze'
  }
];

const ANALYZE_TABBAR_TITLES_NO_REPORT_COMPARE = [
  {
    id: 1,
    label: 'Setup',
    path: '/participants'
  },
  {
    id: 3,
    label: 'Second-by-Second',
    path: '/analyze'
  }
];

const ANALYZE_TABBAR_TITLES_ONLY_PARTICIPANT = [
  {
    id: 1,
    label: 'Setup',
    path: '/participants'
  },
];

const SESSION_SMALL_THUMBNAIL = apiConfigs.S3_IMG_URL + "/large-64.svg"

const AUTO_REFERESH_TIME_PARTICIPANT = 15000

const PAGINATION_PER_PAGE_ITEM = 20;

const YOUTUBE_DATA = [
  {
    url: 'https://www.youtube.com/watch?v=7BFHJJO6FaU',
    title: 'Aviation Gin Ad',
    thumbnail: 'http://i3.ytimg.com/vi/7BFHJJO6FaU/mqdefault.jpg',
    duration: 60,
    category: "ADVERTISING",
    subcategory: "AD",
    streamType: "YOUTUBE",
    stimulusType: "VIDEO"
  },
  {
    url: 'https://www.youtube.com/watch?v=Fp9pNPdNwjI',
    title: 'Black Widow Trailer',
    thumbnail: 'http://i3.ytimg.com/vi/Fp9pNPdNwjI/mqdefault.jpg',
    duration: 121,
    category: "ADVERTISING",
    subcategory: "TRAILER",
    streamType: "YOUTUBE",
    stimulusType: "VIDEO"
  },
  {
    url: 'https://www.youtube.com/watch?v=vRFS0MYTC1I',
    title: 'Beyonce Music Video',
    thumbnail: 'http://i3.ytimg.com/vi/vRFS0MYTC1I/mqdefault.jpg',
    duration: 371,
    category: "ENTERTAINMENT",
    subcategory: "MUSIC",
    streamType: "YOUTUBE",
    stimulusType: "VIDEO"
  },
  {
    url: 'https://www.youtube.com/watch?v=rFAdlU2ETjU&t=8s',
    title: 'Paul Zak Ted Talk',
    thumbnail: 'http://i3.ytimg.com/vi/rFAdlU2ETjU/mqdefault.jpg',
    duration: 994,
    category: "EVENT",
    subcategory: "OTHER",
    streamType: "YOUTUBE",
    stimulusType: "VIDEO"
  }
];

const MODULE4DEMODATA = {
  session: {
    "session_title": "My Experience",
    "session_description": "",
    "started_at": 1631212260,
    "ended_at": 1631212560,
    "scheduled_start_at": 1631212260,
    "scheduled_end_at": 1631212560,
    "session_status": "COMPLETED",
    "session_type": "ASYNC",
    "session_category": "ENTERTAINMENT",
    "active_at": null,
    "deleted_at": null,
    "completed_at": 1631212560,
    "tag_cloud": null,
    "background_stimulus_id": null,
    "icon_stimulus_id": null,
    "related_session_id": null,
    "project_id": null,
    "agenda_json": null,
    "session_subcategory": "TV",
    "small_thumbnail": "https://img.youtube.com/vi/QwievZ1Tx-8/0.jpg",
    "large_thumbnail": "https://img.youtube.com/vi/QwievZ1Tx-8/0.jpg",
    "stimulus_status": "READY",
    "project_folders": null,
    "session_trim_from": null,
    "session_trim_to": null,
    "session_link": "446d9bae-942f-490b-897a-c859b0cff794",
    "sharing_info": {
      "sharing_info": "a media presentation"
    },
    "creator_first_name": "Cris",
    "creator_last_name": "Jurado",
    "creator_username": "crisostomojuradojr@outlook.com",
    "participantscount": 2,
    "agenda_markers": [
      {
        "marker_title": "Big Patch",
        "marker_description": null,
        "start_marker_at": 1631212280,
        "end_marker_at": 1631212285,
        "created_at": "2021-09-10T04:23:59.050Z",
        "updated_at": "2021-09-10T04:23:59.050Z",
        "marker_type": 3,
        "relative_start": 1631212280,
        "relative_end": 1631212285,
        "deleted": false
      },
      {
        "marker_title": "Best Moments",
        "marker_description": null,
        "start_marker_at": 1631212307,
        "end_marker_at": 1631212333,
        "created_at": "2021-09-10T04:24:10.116Z",
        "updated_at": "2021-09-10T04:24:10.116Z",
        "marker_type": 3,
        "relative_start": 1631212307,
        "relative_end": 1631212333,
        "deleted": false
      },
      {
        "marker_title": "Awesome scene",
        "marker_description": null,
        "start_marker_at": 1631212354,
        "end_marker_at": 1631212359,
        "created_at": "2021-09-10T04:24:24.201Z",
        "updated_at": "2021-09-10T04:24:24.201Z",
        "marker_type": 4,
        "relative_start": 1631212354,
        "relative_end": 1631212359,
        "deleted": false
      }
    ],
    "stimulus": [
      {
        "created_at": 1631212214929,
        "stimulus_type": "VIDEO",
        "stimulus_status": "READY",
        "s_stimulus_key": "P:135:7cvfq",
        "stimulus_alias": "MarvelStudiosAvengersInfinityWarOfficialTrailer",
        "thumbnails": [
          {
            "width": 675,
            "url": "https://img.youtube.com/vi/QwievZ1Tx-8/0.jpg",
            "height": 380
          }
        ],
        "stimulus_link": "https://www.youtube.com/watch?v=QwievZ1Tx-8",
        "stimulus_video_length": 139,
        "stream_type": "YOUTUBE",
        "stimulus_id": "4e1474c6-e2dd-4f56-a3c8-d965f08cffd3",
        "sort_id": "VIDEO:4e1474c6-e2dd-4f56-a3c8-d965f08cffd3",
        "updated_at": 1631212214929,
        "validation": "VALID",
        "user_id": "2cfd4199-c73e-482a-884e-cf50ac9d6aba",
        "file_id": "acbf899e-74f4-4d29-ba8d-c19cb4c6d327",
        "stimulus_description": "https://www.youtube.com/watch?v=QwievZ1Tx-8",
        "sort_order": 1
      }
    ],
    "session_length": 139,
    "range_immersion": [],
    "range_safety": [],
    "overall_immersion_index": 29,
    "overall_safety_index": 21,
    "norm_ps": 0,
    "norm_imm": 0,
    "safetyIndex": {
      "safety_index": 78,
      "tier_indicator": "High",
      "color_indicator": "Green",
      "context_indicator": "Very Safe"
    },
    "immersionIndex": {
      "immersion_index": 61,
      "tier_indicator": "Medium",
      "color_indicator": "Gray",
      "context_indicator": "Interested"
    },
    "best_moments": [
      {
        "epoch_start": 74,
        "epoch_end": 90,
        "immersion_index": {
          "overall_index": 93,
          "tier_indicator": "Very High",
          "color_indicator": "Green",
          "context_indicator": "Captivated"
        },
        "safety_index": {
          "overall_index": 1,
          "color_indicator": "Red",
          "tier_indicator": "Very Low",
          "context_indicator": "Very Unsafe"
        }
      },
      {
        "epoch_start": 20,
        "epoch_end": 38,
        "immersion_index": {
          "overall_index": 85,
          "tier_indicator": "High",
          "color_indicator": "Green",
          "context_indicator": "Absorbed"
        },
        "safety_index": {
          "overall_index": 1,
          "color_indicator": "Red",
          "tier_indicator": "Very Low",
          "context_indicator": "Very Unsafe"
        }
      },
      {
        "epoch_start": 47,
        "epoch_end": 52,
        "immersion_index": {
          "overall_index": 78,
          "tier_indicator": "High",
          "color_indicator": "Green",
          "context_indicator": "Absorbed"
        },
        "safety_index": {
          "overall_index": 1,
          "color_indicator": "Red",
          "tier_indicator": "Very Low",
          "context_indicator": "Very Unsafe"
        }
      }
    ],
    "worst_moments": [
      {
        "epoch_start": 123,
        "epoch_end": 134,
        "immersion_index": {
          "overall_index": 28,
          "tier_indicator": "Low",
          "color_indicator": "Red",
          "context_indicator": "Indifferent"
        },
        "safety_index": {
          "overall_index": 78,
          "tier_indicator": "High",
          "color_indicator": "Green",
          "context_indicator": "Very Safe"
        }
      },
      {
        "epoch_start": 92,
        "epoch_end": 100,
        "immersion_index": {
          "overall_index": 22,
          "tier_indicator": "Low",
          "color_indicator": "Red",
          "context_indicator": "Indifferent"
        },
        "safety_index": {
          "overall_index": 1,
          "color_indicator": "Red",
          "tier_indicator": "Very Low",
          "context_indicator": "Very Unsafe"
        }
      }
    ],
    "immersion_contex_breakup": [
      {
        "order": 91,
        "context_indicator": "Captivated",
        "color_indicator": "Green",
        "tier_indicator": "Very High",
        "category_count": 0,
        "category_percent": 0
      },
      {
        "order": 66,
        "context_indicator": "Absorbed",
        "color_indicator": "Green",
        "tier_indicator": "High",
        "category_count": 1,
        "category_percent": 50
      },
      {
        "order": 36,
        "context_indicator": "Interested",
        "color_indicator": "Gray",
        "tier_indicator": "Medium",
        "category_count": 0,
        "category_percent": 0
      },
      {
        "order": 11,
        "context_indicator": "Indifferent",
        "color_indicator": "Red",
        "tier_indicator": "Low",
        "category_count": 1,
        "category_percent": 50
      },
      {
        "order": 1,
        "context_indicator": "Tuned Out",
        "color_indicator": "Red",
        "tier_indicator": "Very Low",
        "category_count": 0,
        "category_percent": 0
      }
    ],
    "safety_contex_breakup": [
      {
        "order": 86,
        "context_indicator": "Zen",
        "color_indicator": "Green",
        "tier_indicator": "Very High",
        "category_count": 1,
        "category_percent": 50
      },
      {
        "order": 66,
        "context_indicator": "Very Safe",
        "color_indicator": "Green",
        "tier_indicator": "High",
        "category_count": 0,
        "category_percent": 0
      },
      {
        "order": 36,
        "context_indicator": "Safe",
        "color_indicator": "Gray",
        "tier_indicator": "Medium",
        "category_count": 1,
        "category_percent": 50
      },
      {
        "order": 16,
        "context_indicator": "Unsafe",
        "color_indicator": "Red",
        "tier_indicator": "Low",
        "category_count": 0,
        "category_percent": 0
      },
      {
        "order": 1,
        "context_indicator": "Very Unsafe",
        "color_indicator": "Red",
        "tier_indicator": "Very Low",
        "category_count": 0,
        "category_percent": 0
      }
    ]
  },
  analyze: {
    "tags": [
      {
        "tag_id": "154",
        "tag_name": "Man"
      },
      {
        "tag_id": "78",
        "tag_name": "Female"
      }
    ],
    "agenda_markers": [
      {
        "marker_title": "Big Patch",
        "marker_description": null,
        "start_marker_at": 1631212280,
        "end_marker_at": 1631212285,
        "created_at": "2021-09-10T04:23:59.050Z",
        "updated_at": "2021-09-10T04:23:59.050Z",
        "marker_type": 3,
        "relative_start": 1631212280,
        "relative_end": 1631212285,
        "deleted": false
      },
      {
        "marker_title": "Best Moments",
        "marker_description": null,
        "start_marker_at": 1631212307,
        "end_marker_at": 1631212333,
        "created_at": "2021-09-10T04:24:10.116Z",
        "updated_at": "2021-09-10T04:24:10.116Z",
        "marker_type": 3,
        "relative_start": 1631212307,
        "relative_end": 1631212333,
        "deleted": false
      },
      {
        "marker_title": "Awesome scene",
        "marker_description": null,
        "start_marker_at": 1631212354,
        "end_marker_at": 1631212359,
        "created_at": "2021-09-10T04:24:24.201Z",
        "updated_at": "2021-09-10T04:24:24.201Z",
        "marker_type": 4,
        "relative_start": 1631212354,
        "relative_end": 1631212359,
        "deleted": false
      }
    ],
    "stimulus": {
      "created_at": 1631212214929,
      "stimulus_type": "VIDEO",
      "stimulus_status": "READY",
      "s_stimulus_key": "P:135:7cvfq",
      "stimulus_alias": "MarvelStudiosAvengersInfinityWarOfficialTrailer",
      "thumbnails": [
        {
          "width": 675,
          "url": "https://img.youtube.com/vi/QwievZ1Tx-8/0.jpg",
          "height": 380
        }
      ],
      "stimulus_link": "https://www.youtube.com/watch?v=QwievZ1Tx-8",
      "stimulus_video_length": 139,
      "stream_type": "YOUTUBE",
      "stimulus_id": "4e1474c6-e2dd-4f56-a3c8-d965f08cffd3",
      "sort_id": "VIDEO:4e1474c6-e2dd-4f56-a3c8-d965f08cffd3",
      "updated_at": 1631212214929,
      "validation": "VALID",
      "user_id": "2cfd4199-c73e-482a-884e-cf50ac9d6aba",
      "file_id": "acbf899e-74f4-4d29-ba8d-c19cb4c6d327",
      "stimulus_description": "https://www.youtube.com/watch?v=QwievZ1Tx-8",
      "sort_order": 1
    },
    "pills": [
      {
        "pill": "GRAY",
        "start": 0,
        "end": 20,
        "overall_index": 40,
        "tier_indicator": "Medium",
        "color_indicator": "Gray",
        "context_indicator": "Interested",
        "moments": []
      },
      {
        "pill": "GREEN",
        "start": 20,
        "end": 39,
        "overall_index": 85,
        "tier_indicator": "High",
        "color_indicator": "Green",
        "context_indicator": "Absorbed",
        "moments": [
          {
            "moment": "GREEN",
            "moment_sum": 94.68,
            "moment_length": 19,
            "moment_average": 4.98,
            "epoch_start": 20,
            "epoch_end": 38,
            "overall_index": 85,
            "tier_indicator": "High",
            "color_indicator": "Green",
            "context_indicator": "Absorbed"
          }
        ]
      },
      {
        "pill": "GRAY",
        "start": 39,
        "end": 47,
        "overall_index": 44,
        "tier_indicator": "Medium",
        "color_indicator": "Gray",
        "context_indicator": "Interested",
        "moments": []
      },
      {
        "pill": "GREEN",
        "start": 47,
        "end": 63,
        "overall_index": 67,
        "tier_indicator": "High",
        "color_indicator": "Green",
        "context_indicator": "Absorbed",
        "moments": [
          {
            "moment": "GREEN",
            "moment_sum": 27.84,
            "moment_length": 6,
            "moment_average": 4.64,
            "epoch_start": 47,
            "epoch_end": 52,
            "overall_index": 78,
            "tier_indicator": "High",
            "color_indicator": "Green",
            "context_indicator": "Absorbed"
          }
        ]
      },
      {
        "pill": "GRAY",
        "start": 63,
        "end": 74,
        "overall_index": 52,
        "tier_indicator": "Medium",
        "color_indicator": "Gray",
        "context_indicator": "Interested",
        "moments": []
      },
      {
        "pill": "GREEN",
        "start": 74,
        "end": 91,
        "overall_index": 93,
        "tier_indicator": "Very High",
        "color_indicator": "Green",
        "context_indicator": "Captivated",
        "moments": [
          {
            "moment": "GREEN",
            "moment_sum": 95.14,
            "moment_length": 17,
            "moment_average": 5.6,
            "epoch_start": 74,
            "epoch_end": 90,
            "overall_index": 93,
            "tier_indicator": "Very High",
            "color_indicator": "Green",
            "context_indicator": "Captivated"
          }
        ]
      },
      {
        "pill": "RED",
        "start": 91,
        "end": 101,
        "overall_index": 24,
        "tier_indicator": "Low",
        "color_indicator": "Red",
        "context_indicator": "Indifferent",
        "moments": [
          {
            "moment": "RED",
            "moment_sum": 28.78,
            "moment_length": 9,
            "moment_average": 3.2,
            "epoch_start": 92,
            "epoch_end": 100,
            "overall_index": 22,
            "tier_indicator": "Low",
            "color_indicator": "Red",
            "context_indicator": "Indifferent"
          }
        ]
      },
      {
        "pill": "GRAY",
        "start": 101,
        "end": 123,
        "overall_index": 45,
        "tier_indicator": "Medium",
        "color_indicator": "Gray",
        "context_indicator": "Interested",
        "moments": []
      },
      {
        "pill": "RED",
        "start": 123,
        "end": 138,
        "overall_index": 31,
        "tier_indicator": "Low",
        "color_indicator": "Red",
        "context_indicator": "Indifferent",
        "moments": [
          {
            "moment": "RED",
            "moment_sum": 40.23,
            "moment_length": 12,
            "moment_average": 3.35,
            "epoch_start": 123,
            "epoch_end": 134,
            "overall_index": 28,
            "tier_indicator": "Low",
            "color_indicator": "Red",
            "context_indicator": "Indifferent"
          }
        ]
      }
    ],
    "psych_readiness": [
      {
        "epoch_start": 120,
        "immersion_index": 78,
        "tier_indicator": "High",
        "color_indicator": "Green",
        "context_indicator": "Very Safe"
      }
    ],
    "immersion_index": {
      "overall_index": 61,
      "overall_tier_indicator": "Medium",
      "overall_color_indicator": "Gray",
      "overall_context_indicator": "Interested",
      "data": [
        {
          "time_stamp": "1970-01-01 00:00:00",
          "immersion_index": 20
        },
        {
          "time_stamp": "1970-01-01 00:00:01",
          "immersion_index": 29
        },
        {
          "time_stamp": "1970-01-01 00:00:02",
          "immersion_index": 35
        },
        {
          "time_stamp": "1970-01-01 00:00:03",
          "immersion_index": 44
        },
        {
          "time_stamp": "1970-01-01 00:00:04",
          "immersion_index": 48
        },
        {
          "time_stamp": "1970-01-01 00:00:05",
          "immersion_index": 48
        },
        {
          "time_stamp": "1970-01-01 00:00:06",
          "immersion_index": 47
        },
        {
          "time_stamp": "1970-01-01 00:00:07",
          "immersion_index": 47
        },
        {
          "time_stamp": "1970-01-01 00:00:08",
          "immersion_index": 42
        },
        {
          "time_stamp": "1970-01-01 00:00:09",
          "immersion_index": 33
        },
        {
          "time_stamp": "1970-01-01 00:00:10",
          "immersion_index": 34
        },
        {
          "time_stamp": "1970-01-01 00:00:11",
          "immersion_index": 37
        },
        {
          "time_stamp": "1970-01-01 00:00:12",
          "immersion_index": 31
        },
        {
          "time_stamp": "1970-01-01 00:00:13",
          "immersion_index": 36
        },
        {
          "time_stamp": "1970-01-01 00:00:14",
          "immersion_index": 37
        },
        {
          "time_stamp": "1970-01-01 00:00:15",
          "immersion_index": 41
        },
        {
          "time_stamp": "1970-01-01 00:00:16",
          "immersion_index": 39
        },
        {
          "time_stamp": "1970-01-01 00:00:17",
          "immersion_index": 42
        },
        {
          "time_stamp": "1970-01-01 00:00:18",
          "immersion_index": 47
        },
        {
          "time_stamp": "1970-01-01 00:00:19",
          "immersion_index": 59
        },
        {
          "time_stamp": "1970-01-01 00:00:20",
          "immersion_index": 71
        },
        {
          "time_stamp": "1970-01-01 00:00:21",
          "immersion_index": 81
        },
        {
          "time_stamp": "1970-01-01 00:00:22",
          "immersion_index": 89
        },
        {
          "time_stamp": "1970-01-01 00:00:23",
          "immersion_index": 92
        },
        {
          "time_stamp": "1970-01-01 00:00:24",
          "immersion_index": 92
        },
        {
          "time_stamp": "1970-01-01 00:00:25",
          "immersion_index": 91
        },
        {
          "time_stamp": "1970-01-01 00:00:26",
          "immersion_index": 87
        },
        {
          "time_stamp": "1970-01-01 00:00:27",
          "immersion_index": 82
        },
        {
          "time_stamp": "1970-01-01 00:00:28",
          "immersion_index": 81
        },
        {
          "time_stamp": "1970-01-01 00:00:29",
          "immersion_index": 83
        },
        {
          "time_stamp": "1970-01-01 00:00:30",
          "immersion_index": 86
        },
        {
          "time_stamp": "1970-01-01 00:00:31",
          "immersion_index": 88
        },
        {
          "time_stamp": "1970-01-01 00:00:32",
          "immersion_index": 90
        },
        {
          "time_stamp": "1970-01-01 00:00:33",
          "immersion_index": 90
        },
        {
          "time_stamp": "1970-01-01 00:00:34",
          "immersion_index": 87
        },
        {
          "time_stamp": "1970-01-01 00:00:35",
          "immersion_index": 83
        },
        {
          "time_stamp": "1970-01-01 00:00:36",
          "immersion_index": 81
        },
        {
          "time_stamp": "1970-01-01 00:00:37",
          "immersion_index": 77
        },
        {
          "time_stamp": "1970-01-01 00:00:38",
          "immersion_index": 74
        },
        {
          "time_stamp": "1970-01-01 00:00:39",
          "immersion_index": 65
        },
        {
          "time_stamp": "1970-01-01 00:00:40",
          "immersion_index": 54
        },
        {
          "time_stamp": "1970-01-01 00:00:41",
          "immersion_index": 43
        },
        {
          "time_stamp": "1970-01-01 00:00:42",
          "immersion_index": 35
        },
        {
          "time_stamp": "1970-01-01 00:00:43",
          "immersion_index": 30
        },
        {
          "time_stamp": "1970-01-01 00:00:44",
          "immersion_index": 31
        },
        {
          "time_stamp": "1970-01-01 00:00:45",
          "immersion_index": 41
        },
        {
          "time_stamp": "1970-01-01 00:00:46",
          "immersion_index": 54
        },
        {
          "time_stamp": "1970-01-01 00:00:47",
          "immersion_index": 71
        },
        {
          "time_stamp": "1970-01-01 00:00:48",
          "immersion_index": 78
        },
        {
          "time_stamp": "1970-01-01 00:00:49",
          "immersion_index": 83
        },
        {
          "time_stamp": "1970-01-01 00:00:50",
          "immersion_index": 83
        },
        {
          "time_stamp": "1970-01-01 00:00:51",
          "immersion_index": 80
        },
        {
          "time_stamp": "1970-01-01 00:00:52",
          "immersion_index": 72
        },
        {
          "time_stamp": "1970-01-01 00:00:53",
          "immersion_index": 59
        },
        {
          "time_stamp": "1970-01-01 00:00:54",
          "immersion_index": 49
        },
        {
          "time_stamp": "1970-01-01 00:00:55",
          "immersion_index": 43
        },
        {
          "time_stamp": "1970-01-01 00:00:56",
          "immersion_index": 43
        },
        {
          "time_stamp": "1970-01-01 00:00:57",
          "immersion_index": 48
        },
        {
          "time_stamp": "1970-01-01 00:00:58",
          "immersion_index": 56
        },
        {
          "time_stamp": "1970-01-01 00:00:59",
          "immersion_index": 64
        },
        {
          "time_stamp": "1970-01-01 00:01:00",
          "immersion_index": 71
        },
        {
          "time_stamp": "1970-01-01 00:01:01",
          "immersion_index": 71
        },
        {
          "time_stamp": "1970-01-01 00:01:02",
          "immersion_index": 68
        },
        {
          "time_stamp": "1970-01-01 00:01:03",
          "immersion_index": 61
        },
        {
          "time_stamp": "1970-01-01 00:01:04",
          "immersion_index": 53
        },
        {
          "time_stamp": "1970-01-01 00:01:05",
          "immersion_index": 51
        },
        {
          "time_stamp": "1970-01-01 00:01:06",
          "immersion_index": 48
        },
        {
          "time_stamp": "1970-01-01 00:01:07",
          "immersion_index": 49
        },
        {
          "time_stamp": "1970-01-01 00:01:08",
          "immersion_index": 53
        },
        {
          "time_stamp": "1970-01-01 00:01:09",
          "immersion_index": 52
        },
        {
          "time_stamp": "1970-01-01 00:01:10",
          "immersion_index": 51
        },
        {
          "time_stamp": "1970-01-01 00:01:11",
          "immersion_index": 48
        },
        {
          "time_stamp": "1970-01-01 00:01:12",
          "immersion_index": 51
        },
        {
          "time_stamp": "1970-01-01 00:01:13",
          "immersion_index": 60
        },
        {
          "time_stamp": "1970-01-01 00:01:14",
          "immersion_index": 74
        },
        {
          "time_stamp": "1970-01-01 00:01:15",
          "immersion_index": 84
        },
        {
          "time_stamp": "1970-01-01 00:01:16",
          "immersion_index": 92
        },
        {
          "time_stamp": "1970-01-01 00:01:17",
          "immersion_index": 94
        },
        {
          "time_stamp": "1970-01-01 00:01:18",
          "immersion_index": 94
        },
        {
          "time_stamp": "1970-01-01 00:01:19",
          "immersion_index": 94
        },
        {
          "time_stamp": "1970-01-01 00:01:20",
          "immersion_index": 94
        },
        {
          "time_stamp": "1970-01-01 00:01:21",
          "immersion_index": 94
        },
        {
          "time_stamp": "1970-01-01 00:01:22",
          "immersion_index": 94
        },
        {
          "time_stamp": "1970-01-01 00:01:23",
          "immersion_index": 94
        },
        {
          "time_stamp": "1970-01-01 00:01:24",
          "immersion_index": 95
        },
        {
          "time_stamp": "1970-01-01 00:01:25",
          "immersion_index": 95
        },
        {
          "time_stamp": "1970-01-01 00:01:26",
          "immersion_index": 95
        },
        {
          "time_stamp": "1970-01-01 00:01:27",
          "immersion_index": 94
        },
        {
          "time_stamp": "1970-01-01 00:01:28",
          "immersion_index": 93
        },
        {
          "time_stamp": "1970-01-01 00:01:29",
          "immersion_index": 86
        },
        {
          "time_stamp": "1970-01-01 00:01:30",
          "immersion_index": 69
        },
        {
          "time_stamp": "1970-01-01 00:01:31",
          "immersion_index": 41
        },
        {
          "time_stamp": "1970-01-01 00:01:32",
          "immersion_index": 21
        },
        {
          "time_stamp": "1970-01-01 00:01:33",
          "immersion_index": 17
        },
        {
          "time_stamp": "1970-01-01 00:01:34",
          "immersion_index": 17
        },
        {
          "time_stamp": "1970-01-01 00:01:35",
          "immersion_index": 21
        },
        {
          "time_stamp": "1970-01-01 00:01:36",
          "immersion_index": 24
        },
        {
          "time_stamp": "1970-01-01 00:01:37",
          "immersion_index": 26
        },
        {
          "time_stamp": "1970-01-01 00:01:38",
          "immersion_index": 23
        },
        {
          "time_stamp": "1970-01-01 00:01:39",
          "immersion_index": 24
        },
        {
          "time_stamp": "1970-01-01 00:01:40",
          "immersion_index": 28
        },
        {
          "time_stamp": "1970-01-01 00:01:41",
          "immersion_index": 37
        },
        {
          "time_stamp": "1970-01-01 00:01:42",
          "immersion_index": 40
        },
        {
          "time_stamp": "1970-01-01 00:01:43",
          "immersion_index": 45
        },
        {
          "time_stamp": "1970-01-01 00:01:44",
          "immersion_index": 44
        },
        {
          "time_stamp": "1970-01-01 00:01:45",
          "immersion_index": 45
        },
        {
          "time_stamp": "1970-01-01 00:01:46",
          "immersion_index": 41
        },
        {
          "time_stamp": "1970-01-01 00:01:47",
          "immersion_index": 39
        },
        {
          "time_stamp": "1970-01-01 00:01:48",
          "immersion_index": 39
        },
        {
          "time_stamp": "1970-01-01 00:01:49",
          "immersion_index": 45
        },
        {
          "time_stamp": "1970-01-01 00:01:50",
          "immersion_index": 52
        },
        {
          "time_stamp": "1970-01-01 00:01:51",
          "immersion_index": 61
        },
        {
          "time_stamp": "1970-01-01 00:01:52",
          "immersion_index": 69
        },
        {
          "time_stamp": "1970-01-01 00:01:53",
          "immersion_index": 69
        },
        {
          "time_stamp": "1970-01-01 00:01:54",
          "immersion_index": 65
        },
        {
          "time_stamp": "1970-01-01 00:01:55",
          "immersion_index": 57
        },
        {
          "time_stamp": "1970-01-01 00:01:56",
          "immersion_index": 47
        },
        {
          "time_stamp": "1970-01-01 00:01:57",
          "immersion_index": 35
        },
        {
          "time_stamp": "1970-01-01 00:01:58",
          "immersion_index": 31
        },
        {
          "time_stamp": "1970-01-01 00:01:59",
          "immersion_index": 34
        },
        {
          "time_stamp": "1970-01-01 00:02:00",
          "immersion_index": 37
        },
        {
          "time_stamp": "1970-01-01 00:02:01",
          "immersion_index": 38
        },
        {
          "time_stamp": "1970-01-01 00:02:02",
          "immersion_index": 39
        },
        {
          "time_stamp": "1970-01-01 00:02:03",
          "immersion_index": 35
        },
        {
          "time_stamp": "1970-01-01 00:02:04",
          "immersion_index": 29
        },
        {
          "time_stamp": "1970-01-01 00:02:05",
          "immersion_index": 25
        },
        {
          "time_stamp": "1970-01-01 00:02:06",
          "immersion_index": 23
        },
        {
          "time_stamp": "1970-01-01 00:02:07",
          "immersion_index": 18
        },
        {
          "time_stamp": "1970-01-01 00:02:08",
          "immersion_index": 26
        },
        {
          "time_stamp": "1970-01-01 00:02:09",
          "immersion_index": 31
        },
        {
          "time_stamp": "1970-01-01 00:02:10",
          "immersion_index": 33
        },
        {
          "time_stamp": "1970-01-01 00:02:11",
          "immersion_index": 32
        },
        {
          "time_stamp": "1970-01-01 00:02:12",
          "immersion_index": 28
        },
        {
          "time_stamp": "1970-01-01 00:02:13",
          "immersion_index": 27
        },
        {
          "time_stamp": "1970-01-01 00:02:14",
          "immersion_index": 29
        },
        {
          "time_stamp": "1970-01-01 00:02:15",
          "immersion_index": 38
        },
        {
          "time_stamp": "1970-01-01 00:02:16",
          "immersion_index": 47
        },
        {
          "time_stamp": "1970-01-01 00:02:17",
          "immersion_index": 54
        },
        {
          "time_stamp": "1970-01-01 00:02:18",
          "immersion_index": 64
        }
      ]
    },
    "overall_immersion": {
      "immersion_index": 61,
      "tier_indicator": "Medium",
      "color_indicator": "Gray",
      "context_indicator": "Interested"
    },
    "overall_safety": {
      "safety_index": 78,
      "tier_indicator": "High",
      "color_indicator": "Green",
      "context_indicator": "Very Safe"
    },
    "participant_analyze": [
      {
        "78": {
          "pills": [
            {
              "pill": "RED",
              "start": 0,
              "end": 12,
              "overall_index": 26,
              "tier_indicator": "Low",
              "color_indicator": "Red",
              "context_indicator": "Indifferent",
              "moments": [
                {
                  "moment": "RED",
                  "moment_sum": 31.89,
                  "moment_length": 10,
                  "moment_average": 3.19,
                  "epoch_start": 0,
                  "epoch_end": 9,
                  "overall_index": 22,
                  "tier_indicator": "Low",
                  "color_indicator": "Red",
                  "context_indicator": "Indifferent"
                }
              ]
            },
            {
              "pill": "GREEN",
              "start": 12,
              "end": 91,
              "overall_index": 92,
              "tier_indicator": "Very High",
              "color_indicator": "Green",
              "context_indicator": "Captivated",
              "moments": [
                {
                  "moment": "GREEN",
                  "moment_sum": 168.58,
                  "moment_length": 30,
                  "moment_average": 5.62,
                  "epoch_start": 12,
                  "epoch_end": 41,
                  "overall_index": 93,
                  "tier_indicator": "Very High",
                  "color_indicator": "Green",
                  "context_indicator": "Captivated"
                },
                {
                  "moment": "GREEN",
                  "moment_sum": 58.51,
                  "moment_length": 10,
                  "moment_average": 5.85,
                  "epoch_start": 45,
                  "epoch_end": 54,
                  "overall_index": 94,
                  "tier_indicator": "Very High",
                  "color_indicator": "Green",
                  "context_indicator": "Captivated"
                },
                {
                  "moment": "GREEN",
                  "moment_sum": 184.63000000000002,
                  "moment_length": 33,
                  "moment_average": 5.59,
                  "epoch_start": 58,
                  "epoch_end": 90,
                  "overall_index": 93,
                  "tier_indicator": "Very High",
                  "color_indicator": "Green",
                  "context_indicator": "Captivated"
                }
              ]
            },
            {
              "pill": "GRAY",
              "start": 91,
              "end": 100,
              "overall_index": 46,
              "tier_indicator": "Medium",
              "color_indicator": "Gray",
              "context_indicator": "Interested",
              "moments": []
            },
            {
              "pill": "GREEN",
              "start": 100,
              "end": 117,
              "overall_index": 79,
              "tier_indicator": "High",
              "color_indicator": "Green",
              "context_indicator": "Absorbed",
              "moments": [
                {
                  "moment": "GREEN",
                  "moment_sum": 79.58999999999999,
                  "moment_length": 17,
                  "moment_average": 4.68,
                  "epoch_start": 100,
                  "epoch_end": 116,
                  "overall_index": 79,
                  "tier_indicator": "High",
                  "color_indicator": "Green",
                  "context_indicator": "Absorbed"
                }
              ]
            },
            {
              "pill": "GRAY",
              "start": 117,
              "end": 138,
              "overall_index": 57,
              "tier_indicator": "Medium",
              "color_indicator": "Gray",
              "context_indicator": "Interested",
              "moments": []
            }
          ],
          "psych_readiness": [
            {
              "epoch_start": 120,
              "immersion_index": 87,
              "tier_indicator": "Very High",
              "color_indicator": "Green",
              "context_indicator": "Zen"
            },
            {
              "epoch_start": 240,
              "immersion_index": 88,
              "tier_indicator": "Very High",
              "color_indicator": "Green",
              "context_indicator": "Zen"
            }
          ],
          "immersion": {
            "overall_index": 84,
            "overall_tier_indicator": "High",
            "overall_color_indicator": "Green",
            "overall_context_indicator": "Absorbed",
            "data": [
              {
                "time_stamp": "1970-01-01 00:00:00",
                "immersion_index": 23
              },
              {
                "time_stamp": "1970-01-01 00:00:01",
                "immersion_index": 23
              },
              {
                "time_stamp": "1970-01-01 00:00:02",
                "immersion_index": 23
              },
              {
                "time_stamp": "1970-01-01 00:00:03",
                "immersion_index": 22
              },
              {
                "time_stamp": "1970-01-01 00:00:04",
                "immersion_index": 21
              },
              {
                "time_stamp": "1970-01-01 00:00:05",
                "immersion_index": 19
              },
              {
                "time_stamp": "1970-01-01 00:00:06",
                "immersion_index": 19
              },
              {
                "time_stamp": "1970-01-01 00:00:07",
                "immersion_index": 22
              },
              {
                "time_stamp": "1970-01-01 00:00:08",
                "immersion_index": 22
              },
              {
                "time_stamp": "1970-01-01 00:00:09",
                "immersion_index": 25
              },
              {
                "time_stamp": "1970-01-01 00:00:10",
                "immersion_index": 42
              },
              {
                "time_stamp": "1970-01-01 00:00:11",
                "immersion_index": 56
              },
              {
                "time_stamp": "1970-01-01 00:00:12",
                "immersion_index": 70
              },
              {
                "time_stamp": "1970-01-01 00:00:13",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:00:14",
                "immersion_index": 79
              },
              {
                "time_stamp": "1970-01-01 00:00:15",
                "immersion_index": 75
              },
              {
                "time_stamp": "1970-01-01 00:00:16",
                "immersion_index": 70
              },
              {
                "time_stamp": "1970-01-01 00:00:17",
                "immersion_index": 69
              },
              {
                "time_stamp": "1970-01-01 00:00:18",
                "immersion_index": 73
              },
              {
                "time_stamp": "1970-01-01 00:00:19",
                "immersion_index": 80
              },
              {
                "time_stamp": "1970-01-01 00:00:20",
                "immersion_index": 88
              },
              {
                "time_stamp": "1970-01-01 00:00:21",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:00:22",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:00:23",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:24",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:25",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:00:26",
                "immersion_index": 91
              },
              {
                "time_stamp": "1970-01-01 00:00:27",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:00:28",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:00:29",
                "immersion_index": 89
              },
              {
                "time_stamp": "1970-01-01 00:00:30",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:00:31",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:32",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:33",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:34",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:35",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:36",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:37",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:38",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:00:39",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:00:40",
                "immersion_index": 88
              },
              {
                "time_stamp": "1970-01-01 00:00:41",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:00:42",
                "immersion_index": 60
              },
              {
                "time_stamp": "1970-01-01 00:00:43",
                "immersion_index": 47
              },
              {
                "time_stamp": "1970-01-01 00:00:44",
                "immersion_index": 55
              },
              {
                "time_stamp": "1970-01-01 00:00:45",
                "immersion_index": 73
              },
              {
                "time_stamp": "1970-01-01 00:00:46",
                "immersion_index": 89
              },
              {
                "time_stamp": "1970-01-01 00:00:47",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:00:48",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:49",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:50",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:51",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:52",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:00:53",
                "immersion_index": 91
              },
              {
                "time_stamp": "1970-01-01 00:00:54",
                "immersion_index": 82
              },
              {
                "time_stamp": "1970-01-01 00:00:55",
                "immersion_index": 65
              },
              {
                "time_stamp": "1970-01-01 00:00:56",
                "immersion_index": 50
              },
              {
                "time_stamp": "1970-01-01 00:00:57",
                "immersion_index": 53
              },
              {
                "time_stamp": "1970-01-01 00:00:58",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:00:59",
                "immersion_index": 85
              },
              {
                "time_stamp": "1970-01-01 00:01:00",
                "immersion_index": 92
              },
              {
                "time_stamp": "1970-01-01 00:01:01",
                "immersion_index": 93
              },
              {
                "time_stamp": "1970-01-01 00:01:02",
                "immersion_index": 93
              },
              {
                "time_stamp": "1970-01-01 00:01:03",
                "immersion_index": 90
              },
              {
                "time_stamp": "1970-01-01 00:01:04",
                "immersion_index": 85
              },
              {
                "time_stamp": "1970-01-01 00:01:05",
                "immersion_index": 80
              },
              {
                "time_stamp": "1970-01-01 00:01:06",
                "immersion_index": 75
              },
              {
                "time_stamp": "1970-01-01 00:01:07",
                "immersion_index": 74
              },
              {
                "time_stamp": "1970-01-01 00:01:08",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:09",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:10",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:11",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:12",
                "immersion_index": 68
              },
              {
                "time_stamp": "1970-01-01 00:01:13",
                "immersion_index": 68
              },
              {
                "time_stamp": "1970-01-01 00:01:14",
                "immersion_index": 77
              },
              {
                "time_stamp": "1970-01-01 00:01:15",
                "immersion_index": 86
              },
              {
                "time_stamp": "1970-01-01 00:01:16",
                "immersion_index": 93
              },
              {
                "time_stamp": "1970-01-01 00:01:17",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:01:18",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:01:19",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:01:20",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:01:21",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:01:22",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:01:23",
                "immersion_index": 98
              },
              {
                "time_stamp": "1970-01-01 00:01:24",
                "immersion_index": 98
              },
              {
                "time_stamp": "1970-01-01 00:01:25",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:01:26",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:01:27",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:01:28",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:01:29",
                "immersion_index": 93
              },
              {
                "time_stamp": "1970-01-01 00:01:30",
                "immersion_index": 83
              },
              {
                "time_stamp": "1970-01-01 00:01:31",
                "immersion_index": 61
              },
              {
                "time_stamp": "1970-01-01 00:01:32",
                "immersion_index": 36
              },
              {
                "time_stamp": "1970-01-01 00:01:33",
                "immersion_index": 28
              },
              {
                "time_stamp": "1970-01-01 00:01:34",
                "immersion_index": 28
              },
              {
                "time_stamp": "1970-01-01 00:01:35",
                "immersion_index": 39
              },
              {
                "time_stamp": "1970-01-01 00:01:36",
                "immersion_index": 45
              },
              {
                "time_stamp": "1970-01-01 00:01:37",
                "immersion_index": 54
              },
              {
                "time_stamp": "1970-01-01 00:01:38",
                "immersion_index": 61
              },
              {
                "time_stamp": "1970-01-01 00:01:39",
                "immersion_index": 65
              },
              {
                "time_stamp": "1970-01-01 00:01:40",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:41",
                "immersion_index": 75
              },
              {
                "time_stamp": "1970-01-01 00:01:42",
                "immersion_index": 77
              },
              {
                "time_stamp": "1970-01-01 00:01:43",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:01:44",
                "immersion_index": 80
              },
              {
                "time_stamp": "1970-01-01 00:01:45",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:01:46",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:47",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:48",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:49",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:50",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:01:51",
                "immersion_index": 84
              },
              {
                "time_stamp": "1970-01-01 00:01:52",
                "immersion_index": 88
              },
              {
                "time_stamp": "1970-01-01 00:01:53",
                "immersion_index": 87
              },
              {
                "time_stamp": "1970-01-01 00:01:54",
                "immersion_index": 84
              },
              {
                "time_stamp": "1970-01-01 00:01:55",
                "immersion_index": 79
              },
              {
                "time_stamp": "1970-01-01 00:01:56",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:57",
                "immersion_index": 59
              },
              {
                "time_stamp": "1970-01-01 00:01:58",
                "immersion_index": 51
              },
              {
                "time_stamp": "1970-01-01 00:01:59",
                "immersion_index": 52
              },
              {
                "time_stamp": "1970-01-01 00:02:00",
                "immersion_index": 55
              },
              {
                "time_stamp": "1970-01-01 00:02:01",
                "immersion_index": 58
              },
              {
                "time_stamp": "1970-01-01 00:02:02",
                "immersion_index": 63
              },
              {
                "time_stamp": "1970-01-01 00:02:03",
                "immersion_index": 60
              },
              {
                "time_stamp": "1970-01-01 00:02:04",
                "immersion_index": 59
              },
              {
                "time_stamp": "1970-01-01 00:02:05",
                "immersion_index": 51
              },
              {
                "time_stamp": "1970-01-01 00:02:06",
                "immersion_index": 53
              },
              {
                "time_stamp": "1970-01-01 00:02:07",
                "immersion_index": 49
              },
              {
                "time_stamp": "1970-01-01 00:02:08",
                "immersion_index": 55
              },
              {
                "time_stamp": "1970-01-01 00:02:09",
                "immersion_index": 61
              },
              {
                "time_stamp": "1970-01-01 00:02:10",
                "immersion_index": 64
              },
              {
                "time_stamp": "1970-01-01 00:02:11",
                "immersion_index": 62
              },
              {
                "time_stamp": "1970-01-01 00:02:12",
                "immersion_index": 54
              },
              {
                "time_stamp": "1970-01-01 00:02:13",
                "immersion_index": 44
              },
              {
                "time_stamp": "1970-01-01 00:02:14",
                "immersion_index": 44
              },
              {
                "time_stamp": "1970-01-01 00:02:15",
                "immersion_index": 52
              },
              {
                "time_stamp": "1970-01-01 00:02:16",
                "immersion_index": 69
              },
              {
                "time_stamp": "1970-01-01 00:02:17",
                "immersion_index": 80
              },
              {
                "time_stamp": "1970-01-01 00:02:18",
                "immersion_index": 86
              }
            ]
          },
          "immersion_index": {
            "immersion_index": 84,
            "tier_indicator": "High",
            "color_indicator": "Green",
            "context_indicator": "Absorbed"
          },
          "safety_index": {
            "safety_index": 88,
            "tier_indicator": "Very High",
            "color_indicator": "Green",
            "context_indicator": "Zen"
          }
        }
      },
      {
        "154": {
          "pills": [
            {
              "pill": "RED",
              "start": 0,
              "end": 12,
              "overall_index": 26,
              "tier_indicator": "Low",
              "color_indicator": "Red",
              "context_indicator": "Indifferent",
              "moments": [
                {
                  "moment": "RED",
                  "moment_sum": 31.89,
                  "moment_length": 10,
                  "moment_average": 3.19,
                  "epoch_start": 0,
                  "epoch_end": 9,
                  "overall_index": 22,
                  "tier_indicator": "Low",
                  "color_indicator": "Red",
                  "context_indicator": "Indifferent"
                }
              ]
            },
            {
              "pill": "GREEN",
              "start": 12,
              "end": 91,
              "overall_index": 92,
              "tier_indicator": "Very High",
              "color_indicator": "Green",
              "context_indicator": "Captivated",
              "moments": [
                {
                  "moment": "GREEN",
                  "moment_sum": 168.58,
                  "moment_length": 30,
                  "moment_average": 5.62,
                  "epoch_start": 12,
                  "epoch_end": 41,
                  "overall_index": 93,
                  "tier_indicator": "Very High",
                  "color_indicator": "Green",
                  "context_indicator": "Captivated"
                },
                {
                  "moment": "GREEN",
                  "moment_sum": 58.51,
                  "moment_length": 10,
                  "moment_average": 5.85,
                  "epoch_start": 45,
                  "epoch_end": 54,
                  "overall_index": 94,
                  "tier_indicator": "Very High",
                  "color_indicator": "Green",
                  "context_indicator": "Captivated"
                },
                {
                  "moment": "GREEN",
                  "moment_sum": 184.63000000000002,
                  "moment_length": 33,
                  "moment_average": 5.59,
                  "epoch_start": 58,
                  "epoch_end": 90,
                  "overall_index": 93,
                  "tier_indicator": "Very High",
                  "color_indicator": "Green",
                  "context_indicator": "Captivated"
                }
              ]
            },
            {
              "pill": "GRAY",
              "start": 91,
              "end": 100,
              "overall_index": 46,
              "tier_indicator": "Medium",
              "color_indicator": "Gray",
              "context_indicator": "Interested",
              "moments": []
            },
            {
              "pill": "GREEN",
              "start": 100,
              "end": 117,
              "overall_index": 79,
              "tier_indicator": "High",
              "color_indicator": "Green",
              "context_indicator": "Absorbed",
              "moments": [
                {
                  "moment": "GREEN",
                  "moment_sum": 79.58999999999999,
                  "moment_length": 17,
                  "moment_average": 4.68,
                  "epoch_start": 100,
                  "epoch_end": 116,
                  "overall_index": 79,
                  "tier_indicator": "High",
                  "color_indicator": "Green",
                  "context_indicator": "Absorbed"
                }
              ]
            },
            {
              "pill": "GRAY",
              "start": 117,
              "end": 138,
              "overall_index": 57,
              "tier_indicator": "Medium",
              "color_indicator": "Gray",
              "context_indicator": "Interested",
              "moments": []
            }
          ],
          "psych_readiness": [
            {
              "epoch_start": 120,
              "immersion_index": 87,
              "tier_indicator": "Very High",
              "color_indicator": "Green",
              "context_indicator": "Zen"
            },
            {
              "epoch_start": 240,
              "immersion_index": 88,
              "tier_indicator": "Very High",
              "color_indicator": "Green",
              "context_indicator": "Zen"
            }
          ],
          "immersion": {
            "overall_index": 84,
            "overall_tier_indicator": "High",
            "overall_color_indicator": "Green",
            "overall_context_indicator": "Absorbed",
            "data": [
              {
                "time_stamp": "1970-01-01 00:00:00",
                "immersion_index": 23
              },
              {
                "time_stamp": "1970-01-01 00:00:01",
                "immersion_index": 23
              },
              {
                "time_stamp": "1970-01-01 00:00:02",
                "immersion_index": 23
              },
              {
                "time_stamp": "1970-01-01 00:00:03",
                "immersion_index": 22
              },
              {
                "time_stamp": "1970-01-01 00:00:04",
                "immersion_index": 21
              },
              {
                "time_stamp": "1970-01-01 00:00:05",
                "immersion_index": 19
              },
              {
                "time_stamp": "1970-01-01 00:00:06",
                "immersion_index": 19
              },
              {
                "time_stamp": "1970-01-01 00:00:07",
                "immersion_index": 22
              },
              {
                "time_stamp": "1970-01-01 00:00:08",
                "immersion_index": 22
              },
              {
                "time_stamp": "1970-01-01 00:00:09",
                "immersion_index": 25
              },
              {
                "time_stamp": "1970-01-01 00:00:10",
                "immersion_index": 42
              },
              {
                "time_stamp": "1970-01-01 00:00:11",
                "immersion_index": 56
              },
              {
                "time_stamp": "1970-01-01 00:00:12",
                "immersion_index": 70
              },
              {
                "time_stamp": "1970-01-01 00:00:13",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:00:14",
                "immersion_index": 79
              },
              {
                "time_stamp": "1970-01-01 00:00:15",
                "immersion_index": 75
              },
              {
                "time_stamp": "1970-01-01 00:00:16",
                "immersion_index": 70
              },
              {
                "time_stamp": "1970-01-01 00:00:17",
                "immersion_index": 69
              },
              {
                "time_stamp": "1970-01-01 00:00:18",
                "immersion_index": 73
              },
              {
                "time_stamp": "1970-01-01 00:00:19",
                "immersion_index": 80
              },
              {
                "time_stamp": "1970-01-01 00:00:20",
                "immersion_index": 88
              },
              {
                "time_stamp": "1970-01-01 00:00:21",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:00:22",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:00:23",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:24",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:25",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:00:26",
                "immersion_index": 91
              },
              {
                "time_stamp": "1970-01-01 00:00:27",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:00:28",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:00:29",
                "immersion_index": 89
              },
              {
                "time_stamp": "1970-01-01 00:00:30",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:00:31",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:32",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:33",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:34",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:35",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:36",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:37",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:38",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:00:39",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:00:40",
                "immersion_index": 88
              },
              {
                "time_stamp": "1970-01-01 00:00:41",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:00:42",
                "immersion_index": 60
              },
              {
                "time_stamp": "1970-01-01 00:00:43",
                "immersion_index": 47
              },
              {
                "time_stamp": "1970-01-01 00:00:44",
                "immersion_index": 55
              },
              {
                "time_stamp": "1970-01-01 00:00:45",
                "immersion_index": 73
              },
              {
                "time_stamp": "1970-01-01 00:00:46",
                "immersion_index": 89
              },
              {
                "time_stamp": "1970-01-01 00:00:47",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:00:48",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:49",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:50",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:00:51",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:00:52",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:00:53",
                "immersion_index": 91
              },
              {
                "time_stamp": "1970-01-01 00:00:54",
                "immersion_index": 82
              },
              {
                "time_stamp": "1970-01-01 00:00:55",
                "immersion_index": 65
              },
              {
                "time_stamp": "1970-01-01 00:00:56",
                "immersion_index": 50
              },
              {
                "time_stamp": "1970-01-01 00:00:57",
                "immersion_index": 53
              },
              {
                "time_stamp": "1970-01-01 00:00:58",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:00:59",
                "immersion_index": 85
              },
              {
                "time_stamp": "1970-01-01 00:01:00",
                "immersion_index": 92
              },
              {
                "time_stamp": "1970-01-01 00:01:01",
                "immersion_index": 93
              },
              {
                "time_stamp": "1970-01-01 00:01:02",
                "immersion_index": 93
              },
              {
                "time_stamp": "1970-01-01 00:01:03",
                "immersion_index": 90
              },
              {
                "time_stamp": "1970-01-01 00:01:04",
                "immersion_index": 85
              },
              {
                "time_stamp": "1970-01-01 00:01:05",
                "immersion_index": 80
              },
              {
                "time_stamp": "1970-01-01 00:01:06",
                "immersion_index": 75
              },
              {
                "time_stamp": "1970-01-01 00:01:07",
                "immersion_index": 74
              },
              {
                "time_stamp": "1970-01-01 00:01:08",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:09",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:10",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:11",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:12",
                "immersion_index": 68
              },
              {
                "time_stamp": "1970-01-01 00:01:13",
                "immersion_index": 68
              },
              {
                "time_stamp": "1970-01-01 00:01:14",
                "immersion_index": 77
              },
              {
                "time_stamp": "1970-01-01 00:01:15",
                "immersion_index": 86
              },
              {
                "time_stamp": "1970-01-01 00:01:16",
                "immersion_index": 93
              },
              {
                "time_stamp": "1970-01-01 00:01:17",
                "immersion_index": 94
              },
              {
                "time_stamp": "1970-01-01 00:01:18",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:01:19",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:01:20",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:01:21",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:01:22",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:01:23",
                "immersion_index": 98
              },
              {
                "time_stamp": "1970-01-01 00:01:24",
                "immersion_index": 98
              },
              {
                "time_stamp": "1970-01-01 00:01:25",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:01:26",
                "immersion_index": 97
              },
              {
                "time_stamp": "1970-01-01 00:01:27",
                "immersion_index": 96
              },
              {
                "time_stamp": "1970-01-01 00:01:28",
                "immersion_index": 95
              },
              {
                "time_stamp": "1970-01-01 00:01:29",
                "immersion_index": 93
              },
              {
                "time_stamp": "1970-01-01 00:01:30",
                "immersion_index": 83
              },
              {
                "time_stamp": "1970-01-01 00:01:31",
                "immersion_index": 61
              },
              {
                "time_stamp": "1970-01-01 00:01:32",
                "immersion_index": 36
              },
              {
                "time_stamp": "1970-01-01 00:01:33",
                "immersion_index": 28
              },
              {
                "time_stamp": "1970-01-01 00:01:34",
                "immersion_index": 28
              },
              {
                "time_stamp": "1970-01-01 00:01:35",
                "immersion_index": 39
              },
              {
                "time_stamp": "1970-01-01 00:01:36",
                "immersion_index": 45
              },
              {
                "time_stamp": "1970-01-01 00:01:37",
                "immersion_index": 54
              },
              {
                "time_stamp": "1970-01-01 00:01:38",
                "immersion_index": 61
              },
              {
                "time_stamp": "1970-01-01 00:01:39",
                "immersion_index": 65
              },
              {
                "time_stamp": "1970-01-01 00:01:40",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:41",
                "immersion_index": 75
              },
              {
                "time_stamp": "1970-01-01 00:01:42",
                "immersion_index": 77
              },
              {
                "time_stamp": "1970-01-01 00:01:43",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:01:44",
                "immersion_index": 80
              },
              {
                "time_stamp": "1970-01-01 00:01:45",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:01:46",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:47",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:48",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:49",
                "immersion_index": 76
              },
              {
                "time_stamp": "1970-01-01 00:01:50",
                "immersion_index": 81
              },
              {
                "time_stamp": "1970-01-01 00:01:51",
                "immersion_index": 84
              },
              {
                "time_stamp": "1970-01-01 00:01:52",
                "immersion_index": 88
              },
              {
                "time_stamp": "1970-01-01 00:01:53",
                "immersion_index": 87
              },
              {
                "time_stamp": "1970-01-01 00:01:54",
                "immersion_index": 84
              },
              {
                "time_stamp": "1970-01-01 00:01:55",
                "immersion_index": 79
              },
              {
                "time_stamp": "1970-01-01 00:01:56",
                "immersion_index": 72
              },
              {
                "time_stamp": "1970-01-01 00:01:57",
                "immersion_index": 59
              },
              {
                "time_stamp": "1970-01-01 00:01:58",
                "immersion_index": 51
              },
              {
                "time_stamp": "1970-01-01 00:01:59",
                "immersion_index": 52
              },
              {
                "time_stamp": "1970-01-01 00:02:00",
                "immersion_index": 55
              },
              {
                "time_stamp": "1970-01-01 00:02:01",
                "immersion_index": 58
              },
              {
                "time_stamp": "1970-01-01 00:02:02",
                "immersion_index": 63
              },
              {
                "time_stamp": "1970-01-01 00:02:03",
                "immersion_index": 60
              },
              {
                "time_stamp": "1970-01-01 00:02:04",
                "immersion_index": 59
              },
              {
                "time_stamp": "1970-01-01 00:02:05",
                "immersion_index": 51
              },
              {
                "time_stamp": "1970-01-01 00:02:06",
                "immersion_index": 53
              },
              {
                "time_stamp": "1970-01-01 00:02:07",
                "immersion_index": 49
              },
              {
                "time_stamp": "1970-01-01 00:02:08",
                "immersion_index": 55
              },
              {
                "time_stamp": "1970-01-01 00:02:09",
                "immersion_index": 61
              },
              {
                "time_stamp": "1970-01-01 00:02:10",
                "immersion_index": 64
              },
              {
                "time_stamp": "1970-01-01 00:02:11",
                "immersion_index": 62
              },
              {
                "time_stamp": "1970-01-01 00:02:12",
                "immersion_index": 54
              },
              {
                "time_stamp": "1970-01-01 00:02:13",
                "immersion_index": 44
              },
              {
                "time_stamp": "1970-01-01 00:02:14",
                "immersion_index": 44
              },
              {
                "time_stamp": "1970-01-01 00:02:15",
                "immersion_index": 52
              },
              {
                "time_stamp": "1970-01-01 00:02:16",
                "immersion_index": 69
              },
              {
                "time_stamp": "1970-01-01 00:02:17",
                "immersion_index": 80
              },
              {
                "time_stamp": "1970-01-01 00:02:18",
                "immersion_index": 86
              }
            ]
          },
          "immersion_index": {
            "immersion_index": 84,
            "tier_indicator": "High",
            "color_indicator": "Green",
            "context_indicator": "Absorbed"
          },
          "safety_index": {
            "safety_index": 88,
            "tier_indicator": "Very High",
            "color_indicator": "Green",
            "context_indicator": "Zen"
          }
        }
      }
    ]
  },
}

const MODULE4DEMOSETTINGS = {
  videoPlayed: 0,
  videoStopped: true,
  addNoteX: -1,
  addNoteY: -1,
  videoPopIn: 0,
  analyseStart: 0,
  analyseEnd: 0,
  graphType: 0,
  filter: true,
  graphZoom: 1.5,
  clickedPillsTime: 0,
  xScroll: 0,
  videoPlaying: false,
  videoSkip: false,
  filterList: ['All'],
  timeline: null
}

export {
  PARTICIPANT_DASHBOARD_MENU,
  PARTICIPANT_TABLE_HEADER,
  PARTICIPANT_TABLE_HEADER_COMLETED,
  PARTICIPANT_TABLE_HEADER_UPCOMING,
  CREATOR_TABLE_SUBHEADER,
  CREATOR_CLIP_TABLE_SUBHEADER,
  CREATOR_TABLE_HEADER,
  CREATOR_TABLE_HEADER_WITH_USER,
  CREATOR_COMPARE_TABLE_HEADER,
  ANALYZE_TABBAR_TITLES,
  SESSION_SMALL_THUMBNAIL,
  AUTO_REFERESH_TIME_PARTICIPANT,
  PAGINATION_PER_PAGE_ITEM,
  YOUTUBE_DATA,
  ANALYZE_TABBAR_TITLES_NO_COMPARE,
  ANALYZE_TABBAR_TITLES_ONLY_PARTICIPANT,
  CREATOR_MOBILE_TABLE_HEADER,
  REEL_MOBILE_TABLE_HEADER,
  REELS_TABLE_HEADER,
  CREATOR_REELS_TABLE_SUBHEADER,
  MODULE4DEMODATA,
  MODULE4DEMOSETTINGS,
  ANALYZE_TABBAR_TITLES_NO_REPORT_COMPARE,
  IMMERSION_CATEGORIES,
  SAFETY_CATEGORIES
}
